package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.OpenInNewW500Rounded: ImageVector
    get() {
        if (_openInNewW500Rounded != null) {
            return _openInNewW500Rounded!!
        }
        _openInNewW500Rounded = Builder(name = "OpenInNewW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.87f, 848.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-554.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(434.5f, 111.87f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadTo(480.0f, 138.22f, 480.0f, 157.37f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(202.87f, 202.87f)
                verticalLineToRelative(554.26f)
                horizontalLineToRelative(554.26f)
                lineTo(757.13f, 525.5f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadTo(783.48f, 480.0f, 802.63f, 480.0f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(231.63f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(202.87f, 848.13f)
                close()
                moveTo(757.13f, 266.28f)
                lineTo(427.0f, 596.41f)
                quadToRelative(-12.67f, 12.68f, -31.59f, 12.56f)
                quadToRelative(-18.91f, -0.12f, -31.58f, -12.8f)
                quadToRelative(-12.68f, -12.67f, -12.68f, -31.7f)
                quadToRelative(0.0f, -19.04f, 12.68f, -31.71f)
                lineToRelative(329.89f, -329.89f)
                lineTo(605.5f, 202.87f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadTo(560.0f, 176.52f, 560.0f, 157.37f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(197.13f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(197.13f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadTo(821.78f, 400.0f, 802.63f, 400.0f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-88.22f)
                close()
            }
        }
        .build()
        return _openInNewW500Rounded!!
    }

private var _openInNewW500Rounded: ImageVector? = null
